import { excludeKeys } from '@repo/common-utils';
import { useUserEventLogger } from '@repo/tracking-service';
import { BoxButton, Description, MainTitle, StickyBottomWrapper } from '@repo/ui';
import { useRouter } from 'next/router';
import { useState } from 'react';

import IllustCoin from '@/assets/illust-icons/fill-coin-gy2-lg.svg';
import { useSectionScrollModel } from '@/components/common/context/SectionScrollModelProvider';
import { LookupResultAdDrawer } from '@/components/tax-refund/lookup/result/LookupResultAdDrawer';
import { useLookupResultRefundData } from '@/components/tax-refund/lookup/result/LookupResultContext';
import { COMMON_PATHS } from '@/lib/constants/paths';
import { zCurrency } from '@/lib/utils/zCurrency';

export function NoRefundContent() {
  const { refundAmount, businessType, displayName } = useLookupResultRefundData();
  const router = useRouter();

  const [isDrawerShow, setIsDrawerShow] = useState(false);

  const { eventAttribute } = useSectionScrollModel();
  const { pageName, sendClickEvent, sendViewEvent } = useUserEventLogger();

  sendViewEvent(`${pageName}_result`, { ...excludeKeys(eventAttribute ?? {}, ['current_section']), amount: 0, grade: 'zero' });

  const handleClick = () => {
    sendClickEvent(`${pageName}_result-unable_ok`, { amount: 0 });
    router.push({
      pathname: `${COMMON_PATHS.환급조회목록}`,
      query: router.query
    });
  };

  const titleText = (
    <>
      <span className={'break-all'}>{businessType === 'corps' ? `'${displayName}'은` : `${displayName}님은`}</span>
      <br />
      아쉽게도 환급액이 없어요...
    </>
  );

  return (
    <>
      <div className="p-normal-medium">
        <MainTitle title={titleText} className={'text-center'}></MainTitle>
        <Description size={'medium'} title={zCurrency(refundAmount, '원', true, '0')} graphic={<IllustCoin />} />
      </div>
      <div className="w-full max-w-[520px]">
        <StickyBottomWrapper supportText={'신규 환급금이 생기면 알려드릴게요!'}>
          <BoxButton size={'large'} className={'w-full'} variant={'tonal-secondary'} onClick={handleClick}>
            확인
          </BoxButton>
        </StickyBottomWrapper>
      </div>

      <LookupResultAdDrawer open={isDrawerShow} onOpenChange={setIsDrawerShow} delay={1500} businessType={businessType} eventAttributes={{ amount: 0 }} />
    </>
  );
}
